import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useParams, useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Divider,
  Flex,
  Heading,
  Image,
  Stack,
  Text,
  useToast,
  Button,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Box,
  Badge,
  HStack,
  VStack,
  Icon,
  Grid,
  GridItem,
  Container,
  SimpleGrid,
  useColorModeValue,
  Tag,
  Tooltip,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useClipboard,
} from "@chakra-ui/react";
import { Carousel } from "react-bootstrap";
import { 
  FaRupeeSign, 
  FaMapMarkerAlt, 
  FaCalendarAlt, 
  FaWeightHanging,
  FaSeedling,
  FaLeaf,
  FaThermometerHalf,
  FaShare,
  FaWhatsapp,
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaCopy
} from "react-icons/fa";
import MapComponent from "./MapComponent";
import { ChevronRightIcon } from "@chakra-ui/icons";
import Modallogin from "./Modallogin";
import Loading from "./resources/Loading";
import NotFoundComponent from "./resources/NotFound";
import Weather from "./components/Weather/Weather";

const PreviewAd = ({auth}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [own, setOwn] = useState();
  const [loading, setLoading] = useState(true);
  const [NotFound, setNotFound] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const authToken = localStorage.getItem("authToken");
  const toast = useToast();

  // Share functionality - moved to top level
  const currentUrl = window.location.href;
  const shareTitle = `${data.title} - ₹${data.price}`;
  const shareText = `Check out this ${data.catagory} listing: ${data.title} for ₹${data.price}`;
  
  const { onCopy, hasCopied } = useClipboard(currentUrl);

  // Color scheme
  const bgColor = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("gray.700", "gray.200");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const pageBg = useColorModeValue("gray.50", "gray.900");
  const highlightColor = useColorModeValue("green.500", "green.300");
  const cardShadow = useColorModeValue("sm", "dark-lg");
  const productDetailsBg = useColorModeValue("gray.50", "gray.700");

  // for register and login
  const [staticModal, setStaticModal] = useState(false);
  const toggleShow = () => setStaticModal(!staticModal);

  const fetchData = async () => {
    try {
      const response = await axios.post(
        `https://api.agromanch.com/previewad/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      setOwn(response.data.own);
      setData(response.data.product);
      setLoading(false); // Set loading state to false when data is fetched successfully
    } catch (error) {
      // when not logged in
      setOwn(false);
      try{
        const notlogedindata = await axios.post(`https://api.agromanch.com/previewad/notloggedin/${id}`);
        setData(notlogedindata.data.product);
        setLoading(false); // Set loading state to false when data is fetched successfully
      }
      catch(e){
        setLoading(false);
        setNotFound(true); 
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return <Loading />;
  }
  if (NotFound) {
    return <NotFoundComponent />;
  }

  const handleRemove = async () => {
    try {
      setIsRemoving(true);
      await axios.delete(`https://api.agromanch.com/myads_delete/${id}`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setIsRemoving(false);
      toast({
        title: "Ad Removed",
        description: "The ad has been successfully removed.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      navigate("/myads");
    } catch (error) {
      setIsRemoving(false);
      toast({
        title: "Error",
        description: "An error occurred while removing the ad.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };
  
  const handleClick = async function(){
    if(auth){
     window.location.href = `/chat/${id}/${data.useremail}`
    }
    else{
    toggleShow();
    }
  }

  const handleShare = (platform) => {
    const encodedUrl = encodeURIComponent(currentUrl);
    const encodedText = encodeURIComponent(shareText);
    const encodedTitle = encodeURIComponent(shareTitle);

    let shareUrl = '';
    
    switch (platform) {
      case 'whatsapp':
        shareUrl = `https://wa.me/?text=${encodedText}%20${encodedUrl}`;
        break;
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
        break;
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`;
        break;
      case 'linkedin':
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
        break;
      default:
        return;
    }
    
    window.open(shareUrl, '_blank', 'noopener,noreferrer');
  };

  const handleCopyLink = () => {
    onCopy();
    toast({
      title: "Link Copied!",
      description: "Product link has been copied to clipboard.",
      status: "success",
      duration: 2000,
      isClosable: true,
    });
  };
  
  const address = data.address?.[0] || {};

  // Get product images from both productpic fields and images array
  let ProductPics = [];
  
  // First try to get images from the images array
  if (data.images && data.images.length > 0) {
    ProductPics = [...data.images];
    console.log("Using images array:", ProductPics);
  } else {
    // Fallback to productpic fields
    ProductPics = Object.keys(data)
      .filter((key) => key.startsWith("productpic") && data[key])
      .map((key) => data[key]);
    console.log("Using productpic fields:", ProductPics);
  }
  
  // Ensure we have at least one image
  if (ProductPics.length === 0 && data.productpic1) {
    ProductPics = [data.productpic1];
    console.log("Fallback to productpic1:", ProductPics);
  }

  const createdAt = new Date(data.createdAt);
  const now = new Date();
  // Calculate the time difference in milliseconds
  const timeDiff = now.getTime() - createdAt.getTime();
  // Convert milliseconds to days
  const daysAgo = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

  return (
    <Box bg={pageBg} minH="100vh" py={6}>
      <Container maxW="container.xl">
        {/* Breadcrumb Navigation */}
        <Box mb={4} bg={bgColor} p={3} borderRadius="lg" boxShadow={cardShadow}>
          <Breadcrumb
            spacing="8px"
            separator={<ChevronRightIcon color="gray.500" />}
            fontSize="sm"
          >
            <BreadcrumbItem>
              <BreadcrumbLink as={Link} to="/" color={highlightColor}>
                Home
              </BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbItem>
              <BreadcrumbLink as={Link} to={`/${data.catagory}`} color={highlightColor}>
                {data.catagory}
              </BreadcrumbLink>
            </BreadcrumbItem>

            {data.subcatagory && (
              <BreadcrumbItem>
                <BreadcrumbLink as={Link} to={`/${data.subcatagory}`} color={highlightColor}>
                  {data.subcatagory}
                </BreadcrumbLink>
              </BreadcrumbItem>
            )}

            <BreadcrumbItem isCurrentPage>
              <BreadcrumbLink>{data.title}</BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>
        </Box>

        {/* Main Content */}
        <Grid templateColumns={{ base: "1fr", md: "2fr 1fr" }} gap={6}>
          {/* Left Column - Product Images and Description */}
          <GridItem>
            <Card bg={bgColor} borderRadius="lg" overflow="hidden" boxShadow={cardShadow} mb={6}>
              <CardBody p={0}>
                {/* Image Carousel */}
                <Box position="relative" height={{ base: "300px", md: "400px" }}>
                  <Carousel 
                    activeIndex={activeImageIndex}
                    onSelect={(index) => setActiveImageIndex(index)}
                    interval={null}
                  >
                    {ProductPics.map((pic, idx) => (
                      <Carousel.Item key={idx}>
                        <Box 
                          height={{ base: "300px", md: "400px" }} 
                          width="100%" 
                          position="relative"
                        >
                          <Image 
                            src={pic} 
                            alt={`Product image ${idx + 1}`}
                            objectFit="cover"
                            width="100%"
                            height="100%"
                          />
                        </Box>
                      </Carousel.Item>
                    ))}
                  </Carousel>
                  
                  {/* Image counter badge */}
                  <Badge 
                    position="absolute" 
                    bottom="10px" 
                    right="10px" 
                    bg="blackAlpha.700" 
                    color="white"
                    px={2}
                    py={1}
                    borderRadius="md"
                  >
                    {activeImageIndex + 1} / {ProductPics.length}
                  </Badge>
                </Box>
                
                {/* Thumbnail navigation */}
                {ProductPics.length > 1 && (
                  <HStack spacing={2} p={4} overflowX="auto" css={{
                    '&::-webkit-scrollbar': { height: '6px' },
                    '&::-webkit-scrollbar-track': { background: '#f1f1f1' },
                    '&::-webkit-scrollbar-thumb': { background: '#c5c5c5', borderRadius: '10px' }
                  }}>
                    {ProductPics.map((pic, idx) => (
                      <Box 
                        key={idx}
                        width="60px"
                        height="60px"
                        borderRadius="md"
                        overflow="hidden"
                        cursor="pointer"
                        borderWidth={activeImageIndex === idx ? "2px" : "0px"}
                        borderColor={highlightColor}
                        onClick={() => setActiveImageIndex(idx)}
                      >
                        <Image 
                          src={pic}
                          alt={`Thumbnail ${idx + 1}`}
                          objectFit="cover"
                          width="100%"
                          height="100%"
                        />
                      </Box>
                    ))}
                  </HStack>
                )}
              </CardBody>
              
              <Divider />
              
              {/* Product Title and Price */}
              <CardBody>
                <Flex justify="space-between" align="flex-start" mb={4}>
                  <Heading size="lg" color={textColor}>{data.title}</Heading>
                  <VStack spacing={2}>
                    <HStack>
                      <Icon as={FaRupeeSign} color={highlightColor} />
                      <Heading size="lg" color={highlightColor}>
                        {data.price}
                        {data.priceUnit && (
                          <Text as="span" fontSize="md" color="gray.500" ml={1}>
                            /{data.priceUnit}
                          </Text>
                        )}
                      </Heading>
                    </HStack>
                    <Menu>
                      <MenuButton
                        as={IconButton}
                        icon={<FaShare />}
                        variant="ghost"
                        colorScheme="green"
                        aria-label="Share"
                        size="sm"
                        display={{ base: "none", md: "flex" }}
                      />
                      <MenuList>
                        <MenuItem icon={<FaWhatsapp />} onClick={() => handleShare('whatsapp')}>
                          WhatsApp
                        </MenuItem>
                        <MenuItem icon={<FaFacebook />} onClick={() => handleShare('facebook')}>
                          Facebook
                        </MenuItem>
                        <MenuItem icon={<FaTwitter />} onClick={() => handleShare('twitter')}>
                          Twitter
                        </MenuItem>
                        <MenuItem icon={<FaLinkedin />} onClick={() => handleShare('linkedin')}>
                          LinkedIn
                        </MenuItem>
                        <MenuItem icon={<FaCopy />} onClick={handleCopyLink}>
                          {hasCopied ? 'Copied!' : 'Copy Link'}
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </VStack>
                </Flex>
                
                {data.quality && (
                  <Badge 
                    colorScheme={data.quality === 'A' ? 'green' : data.quality === 'B' ? 'blue' : 'orange'}
                    mb={4}
                    px={2}
                    py={1}
                    borderRadius="md"
                  >
                    Grade {data.quality} Quality
                  </Badge>
                )}
                
                <HStack spacing={4} mb={6} wrap="wrap">
                  <Tag size="md" variant="subtle" colorScheme="green">
                    {data.catagory}
                  </Tag>
                  {data.subcatagory && (
                    <Tag size="md" variant="subtle" colorScheme="blue">
                      {data.subcatagory}
                    </Tag>
                  )}
                  <Tag size="md" variant="subtle" colorScheme="gray">
                    <Icon as={FaCalendarAlt} mr={1} />
                    {daysAgo === 0 ? 'Today' : daysAgo === 1 ? 'Yesterday' : `${daysAgo} days ago`}
                  </Tag>
                </HStack>
                
                <VStack align="start" spacing={4}>
                  <Box>
                    <Heading size="md" mb={2}>Description</Heading>
                    <Text color={textColor}>{data.description}</Text>
                  </Box>
                  
                  {/* Agriculture-specific details */}
                  {(data.quantity || data.unit || data.variety || data.cultivationMethod || 
                    data.harvestDate || data.quality || data.breed || data.age) && (
                    <Box 
                      bg={productDetailsBg} 
                      p={4} 
                      borderRadius="md" 
                      width="100%"
                    >
                      <Heading size="md" mb={3}>Product Details</Heading>
                      <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={4}>
                        {data.quantity && data.unit && (
                          <HStack>
                            <Icon as={FaWeightHanging} color={highlightColor} />
                            <Text fontWeight="bold" mr={2}>Quantity:</Text>
                            <Text>{data.quantity} {data.unit}</Text>
                          </HStack>
                        )}
                        
                        {data.variety && (
                          <HStack>
                            <Icon as={FaSeedling} color={highlightColor} />
                            <Text fontWeight="bold" mr={2}>Variety:</Text>
                            <Text>{data.variety}</Text>
                          </HStack>
                        )}
                        
                        {data.cultivationMethod && (
                          <HStack>
                            <Icon as={FaLeaf} color={highlightColor} />
                            <Text fontWeight="bold" mr={2}>Cultivation:</Text>
                            <Text>{data.cultivationMethod.charAt(0).toUpperCase() + data.cultivationMethod.slice(1)}</Text>
                          </HStack>
                        )}
                        
                        {data.harvestDate && (
                          <HStack>
                            <Icon as={FaCalendarAlt} color={highlightColor} />
                            <Text fontWeight="bold" mr={2}>Harvest Date:</Text>
                            <Text>{new Date(data.harvestDate).toLocaleDateString('en-IN')}</Text>
                          </HStack>
                        )}
                        
                        {/* Livestock specific information */}
                        {data.breed && (
                          <HStack>
                            <Text fontWeight="bold" mr={2}>Breed:</Text>
                            <Text>{data.breed}</Text>
                          </HStack>
                        )}
                        
                        {data.age && (
                          <HStack>
                            <Text fontWeight="bold" mr={2}>Age:</Text>
                            <Text>{data.age} months</Text>
                          </HStack>
                        )}
                      </SimpleGrid>
                    </Box>
                  )}
                </VStack>
              </CardBody>
            </Card>
          </GridItem>

          {/* Right Column - Seller Info, Location, etc. */}
          <GridItem>
            {/* Price Card (Mobile Only) */}
            <Card 
              bg={bgColor} 
              borderRadius="lg" 
              boxShadow={cardShadow} 
              mb={6} 
              display={{ base: "block", md: "none" }}
            >
              <CardBody>
                <Flex justify="space-between" align="center">
                  <HStack>
                    <Icon as={FaRupeeSign} color={highlightColor} boxSize={5} />
                    <Heading size="lg" color={highlightColor}>
                      {data.price}
                      {data.priceUnit && (
                        <Text as="span" fontSize="md" color="gray.500" ml={1}>
                          /{data.priceUnit}
                        </Text>
                      )}
                    </Heading>
                  </HStack>
                  
                  <HStack>
                    <Menu>
                      <MenuButton
                        as={IconButton}
                        icon={<FaShare />}
                        variant="ghost"
                        colorScheme="green"
                        aria-label="Share"
                        size="sm"
                      />
                      <MenuList>
                        <MenuItem icon={<FaWhatsapp />} onClick={() => handleShare('whatsapp')}>
                          WhatsApp
                        </MenuItem>
                        <MenuItem icon={<FaFacebook />} onClick={() => handleShare('facebook')}>
                          Facebook
                        </MenuItem>
                        <MenuItem icon={<FaTwitter />} onClick={() => handleShare('twitter')}>
                          Twitter
                        </MenuItem>
                        <MenuItem icon={<FaLinkedin />} onClick={() => handleShare('linkedin')}>
                          LinkedIn
                        </MenuItem>
                        <MenuItem icon={<FaCopy />} onClick={handleCopyLink}>
                          {hasCopied ? 'Copied!' : 'Copy Link'}
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </HStack>
                </Flex>
              </CardBody>
            </Card>
            
            {/* Seller Card */}
            <Card bg={bgColor} borderRadius="lg" boxShadow={cardShadow} mb={6}>
              <CardHeader pb={2}>
                <Heading size="md">Seller Information</Heading>
              </CardHeader>
              <CardBody pt={0}>
                {own ? (
                  <Link to="/profile" style={{ textDecoration: "none" }}>
                    <Flex align="center" mb={4}>
                      <Image
                        src={data.picture || "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"}
                        alt="Profile"
                        boxSize="60px"
                        borderRadius="full"
                        mr={3}
                        border="2px solid"
                        borderColor={borderColor}
                      />
                      <Box>
                        <Heading size="md">{data.owner}</Heading>
                        <Text fontSize="sm" color="gray.500">This is your listing</Text>
                      </Box>
                    </Flex>
                    <Button
                      colorScheme="red"
                      variant="outline"
                      size="md"
                      width="100%"
                      onClick={(e) => {
                        e.preventDefault();
                        handleRemove();
                      }}
                      isLoading={isRemoving}
                      loadingText="Removing"
                    >
                      Remove Listing
                    </Button>
                  </Link>
                ) : (
                  <>
                    <Link to={`/profile/${data.useremail}`} style={{ textDecoration: "none" }}>
                      <Flex align="center" mb={4}>
                        <Image
                          src={data.ownerpicture || "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"}
                          alt="Profile"
                          boxSize="60px"
                          borderRadius="full"
                          mr={3}
                          border="2px solid"
                          borderColor={borderColor}
                        />
                        <Box>
                          <Heading size="md">{data.owner}</Heading>
                          <Text fontSize="sm" color="gray.500">View seller profile</Text>
                        </Box>
                      </Flex>
                    </Link>
                    <Button
                      colorScheme="green"
                      size="md"
                      width="100%"
                      onClick={handleClick}
                      leftIcon={<Icon as={FaShare} />}
                    >
                      Chat With Seller
                    </Button>
                  </>
                )}
              </CardBody>
            </Card>

            {/* Location Card */}
            <Card bg={bgColor} borderRadius="lg" boxShadow={cardShadow} mb={6}>
              <CardHeader pb={2}>
                <Heading size="md">Location</Heading>
              </CardHeader>
              <CardBody pt={0}>
                <HStack mb={4}>
                  <Icon as={FaMapMarkerAlt} color={highlightColor} />
                  <Text>
                    {`${address.area || ''}, ${address.city || ''}, ${address.state || ''} ${address.postcode || ''}`}
                  </Text>
                </HStack>
                
                {data.latitude && data.longitude && (
                  <Box 
                    borderRadius="md" 
                    overflow="hidden" 
                    height="200px" 
                    mb={4}
                    borderWidth="1px"
                    borderColor={borderColor}
                  >
                    <MapComponent lat={data.latitude} lng={data.longitude} />
                  </Box>
                )}
              </CardBody>
            </Card>
            
            {/* Weather Card */}
            {data.latitude && data.longitude && (
              <Card bg={bgColor} borderRadius="lg" boxShadow={cardShadow}>
                <CardHeader pb={2}>
                  <HStack>
                    <Icon as={FaThermometerHalf} color={highlightColor} />
                    <Heading size="md">Local Weather</Heading>
                  </HStack>
                </CardHeader>
                <CardBody pt={0}>
                  <Weather lat={data.latitude} lng={data.longitude} />
                </CardBody>
              </Card>
            )}
          </GridItem>
        </Grid>
      </Container>
      
      <Modallogin
        setStaticModal={setStaticModal}
        toggleShow={toggleShow}
        staticModal={staticModal}
      />
    </Box>
  );
};

export default PreviewAd;